import { BaseService } from '@estee/elc-service';
import { ServiceInitializer } from '@estee/elc-universal-utils';
import { isVulcan } from '~utils/isVulcan';
import { defaultConfigs } from '~sharedComponents/configs';
import Config from '../internal/domain/entities/Config/Config';

export const { name, version } = __serviceInfo__;

function getConfig() {
    const emptyDefaultConfig = {
        cart: {},
        perlgem: {},
        stardust: {}
    };
    // @ts-ignore
    const { cart, perlgem, stardust } = window?.site?.config || emptyDefaultConfig;

    return { ...defaultConfigs, ...cart, perlgem, stardust };
}

export const serviceNames = {
    serviceBusController: 'SERVICE_BUS_CONTROLLER',
    httpTransport: 'HTTP_TRANSPORT',
    config: 'OFFERS_CONFIG',
    configRepository: 'OFFERS_CONFIG_REPOSITORY',
    businessUnitIdParser: 'BUSINESS_UNIT_ID_PARSER',
    cartOffers: 'CART_OFFERS',
    offersApiSdk: 'OFFERS_API_SDK',
    offersRepository: 'OFFERS_REPOSITORY',
    offersViewController: 'OFFERS_VIEW_CONTROLLER',
    offersService: 'CART_SIDEBAR_OFFERS_SERVICE',
    offerCodeModuleViewController: 'CART_SIDEBAR_OFFER_CODES_MODULE_VIEW_CONTROLLER',
    samplesRepository: 'SAMPLES_REPOSITORY',
    samplesController: 'SAMPLES_VIEW_CONTROLLER',
    cartRepository: 'CART_REPOSITORY'
};

async function vulcanSetup() {
    try {
        const siteConfig = getConfig();

        const getDiContainer = () => import('~setup/diContainer');

        const { diContainer, setConfig } = await getDiContainer();

        const diContainerConfig: Config = diContainer.get(serviceNames.config);
        if (!diContainerConfig.config) {
            setConfig(siteConfig);
        }
        diContainerConfig.updateConfig(siteConfig);

    } catch (error) {
        console.error('Failed to initialize offers setup', JSON.stringify(error));
    }
}

export class OffersService extends BaseService {
    constructor(serviceInitializer: ServiceInitializer) {
        const fn = !isVulcan() ? serviceInitializer : vulcanSetup;

        super(name, version, fn);
    }
}
